import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowForm from '@sourceflow-uk/sourceflowform';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from "next/link"
import styles from './styles.module.scss';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import SimpleForm from '/components/SimpleForm';
import imageMetaData from "../../.sourceflow/image_metadata.json";

export default function BlogDetails({
    global,
    pathPrefix,
    customClass = "",
    post,
    buttonLink,
    buttonTitle,
    formId,
    successPageUrl,
    footer_cta_button = false,
    footer_cta_button_link_1,
    footer_cta_button_title_1,
    footer_popUpModal = false,
    dialog_content_1,
    footer_popUpModal_form_id,
    locale
}) {
    Fancybox.bind("[data-src]", {
        // Your custom options
    });
    return (
        <section className={`${styles.root} ${customClass}`}>
            {buttonLink ?
                <Container className="top-row">
                    <Link href={buttonLink}>
                        <a className="text-nowrap arrow-left d-inline-flex align-items-center"><strong>{buttonTitle}</strong></a>
                    </Link>
                </Container>
                : ""}
            <Row className="mx-0 mt-5">
                <Col lg={4} className="pe-lg-5 ps-lg-0 mb-mb-5">
                    <SourceFlowImage
                        src={post?.image ? post?.image : "/site-assets/placeholders/img-placeholder.jpg"}
                        size="800x"
                        alt={post?.title}
                        className="card-img rounded-0 mb-4"
                        imagesMetaData={imageMetaData}
                        path={pathPrefix ? pathPrefix : (`${pathPrefix}.image`) }
                    />
                </Col>
                <Col lg={8} className="pe-lg-5">
                    {locale == "us" ?
                        post?.us_content ? <div className="post-content" dangerouslySetInnerHTML={{ __html: post?.us_content }} /> : ""
                        :
                        post?.content ?
                            <div className="post-content" dangerouslySetInnerHTML={{ __html: post?.content }} />
                            : ""}

                    {footer_cta_button ?
                        footer_popUpModal ?
                            <>
                                <button className="border-0 fancyBox primaryBtn no-arrow" data-src={`#dialog-content-1`}>
                                    {footer_cta_button_title_1}
                                </button>
                                <div class="dialog-content" id="dialog-content-1">
                                    <div>
                                        {dialog_content_1 ?
                                            <>
                                                <SourceFlowText global={global} path={`${pathPrefix}.dialog-content-1`} type="html">
                                                    {dialog_content_1}
                                                </SourceFlowText> <hr></hr>
                                            </> : null}

                                        <SimpleForm
                                            formId={`${footer_popUpModal_form_id}`}
                                            successPageUrl={`${successPageUrl}`}
                                        />
                                    </div>
                                </div>
                            </> :
                            <Link href={`${footer_cta_button_link_1}`}>
                                <a className="primaryBtn no-arrow">
                                    {footer_cta_button_title_1}
                                </a>
                            </Link>
                        :
                        post?.content_footer_button_1_url ?
                            <div className="mt-4">
                                <Link href={`${post?.content_footer_button_1_url}`}>
                                    <a className="primaryBtn no-arrow">
                                        {post?.content_footer_button_1_title}
                                    </a>
                                </Link>
                            </div> : null
                    }
                </Col>
            </Row>
        </section>

    )
}